import React from 'react';
import { Grid, Typography } from '@mui/material';
import ClaimsTable from 'components/claims/ClaimsPage/ClaimsTable';
import { Claim } from 'store/types/Claim';
import ClaimsTableType from 'store/enums/ClaimsTableType';
import { defaultGridContainerProps, defaultGridItemProps } from 'util/Layout';

import styles from 'components/claims/ClaimsPage/ClaimsPage.module.scss';

interface Props {
  underReviewClaims?: Claim[];
  companyId?: string;
  loading?: boolean;
}

const ReviewClaimsTab: React.FunctionComponent<Props> = ({ underReviewClaims, companyId, loading }) => {
  return (
    <Grid {...defaultGridContainerProps}>
      <Grid {...defaultGridItemProps}>
        <Typography variant="h2" className={styles.tableTitle}>
          {'Under Review'}
        </Typography>
        <ClaimsTable
          tableType={ClaimsTableType.UnderReviewClaims}
          data={underReviewClaims}
          loading={loading}
          companyId={companyId}
        />
      </Grid>
    </Grid>
  );
};

export default ReviewClaimsTab;
